import { useState, useEffect, useCallback } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { meetingsAPI } from '../../lib/api';
import MeetingListRow from './MeetingListRow';

export default function ToReviewTab() {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await meetingsAPI.list({ view: 'review', status: 'SUBMITTED' });
      setMeetings(res.data.meetings || []);
    } catch { toast.error('Failed to load reports to review'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="flex justify-center py-12"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="space-y-2" data-testid="to-review-tab">
      {meetings.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-8" data-testid="no-reviews-due-msg">Nothing waiting on your review.</p>
      ) : (
        meetings.map((m) => <MeetingListRow key={m.id} meeting={m} />)
      )}
    </div>
  );
}
